import { render, staticRenderFns } from "./upload-vr-dialog.vue?vue&type=template&id=30a0a424&scoped=true&"
import script from "./upload-vr-dialog.vue?vue&type=script&lang=js&"
export * from "./upload-vr-dialog.vue?vue&type=script&lang=js&"
import style0 from "./upload-vr-dialog.vue?vue&type=style&index=0&id=30a0a424&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a0a424",
  null
  
)

export default component.exports